// Server Component exports (react-server environment)
// This file is used when code runs in a Server Component

// Server-only utilities that use next/headers
export { auth, type InsforgeAuth } from './server/auth';
export { getAuthFromCookies } from './server/InsforgeProvider';

// Server Provider (deprecated but exported for backward compatibility)
export {
  InsforgeServerProvider,
  type InsforgeServerProviderProps,
  type InsforgeProviderServerProps,
} from './server/InsforgeProvider';
